import React, { useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { setupIdleTimeout } from '../utils/idleTimeout'

/**
 * IdleTimeoutManager Component
 * Ensures idle timeout is initialized for authenticated users
 * Works for both new logins and existing sessions
 */
export const IdleTimeoutManager: React.FC = () => {
  const { instance, accounts } = useMsal()

  useEffect(() => {
    // Only set up idle timeout if user is authenticated
    if (accounts.length > 0) {
      console.log('User authenticated - initializing idle timeout')
      setupIdleTimeout(instance)
    }
  }, [instance, accounts])

  // This component doesn't render anything
  return null
}
